import '@/scss/page-templates/equitable-access.scss';
import icon01ImgUrl from '@/images/equitable/map_icon_active01.png';
import iconInactive from '@/images/equitable/map_icon_inactive.png';

import { DefaultRenderer, MarkerClusterer, Renderer } from "@googlemaps/markerclusterer";



let map: google.maps.Map;
let tempData:any[] = [
  {
    name: "School 1",
    address: "Address",
    position: { 
      lat: 39.67554165568873, 
      lng: -104.781339573963 
    }, //
    activeIcon: "",
    inactiveIcon: "",
  },
  {
    name: "Ralston Valley High School",
    address: "Address",
    position: { 
      lat: 39.84359968523259, 
      lng: -105.15063080190177
    }, //
    activeIcon: "",
    inactiveIcon: "",
  },
  {
    name: "Eaglecrest High School",
    address: "Address",
    position: { 
      lat: 39.62443069424432, 
      lng: -104.73449177492796
    }, //
    activeIcon: "",
    inactiveIcon: "",
  },
];

async function initMap(): Promise<void> {
  const { Map } = await google.maps.importLibrary("maps") as google.maps.MapsLibrary;
  const { AdvancedMarkerElement } = await google.maps.importLibrary("marker") as google.maps.MarkerLibrary;

  let data:any[] = tempData;
  if( window.schoolsData ) {
    data = schoolsData;
  }

  map = new Map(document.getElementById("equitableMap") as HTMLElement, {
    center: { lat: 39.03277032221151, lng: -105.62143190178423 },
    // center: { lat: 39.74414779931088, lng: -105.02005964592847 }, // Center it at Denver Broncos Mile High stadium
    zoom: 7,
    streetViewControl: false,
    fullscreenControl: false,
    mapId: 'ALLIN', // DEMO_MAP_ID
  });
  map.addListener('zoom_changed', () => {
    console.log('map zoom level:', map.getZoom());
  })

  // let icon01Img = document.createElement('img');
  // icon01Img.src = iconInactive;
  // icon01Img.width = 27;
  // icon01Img.height = 34;

  let markers:any[] = [];
  for( let i=0; i<data.length; i++ ) {
    let icon01Img = document.createElement('img');
    icon01Img.classList.add('equitable__gmap-icon');
    icon01Img.src = iconInactive;
    icon01Img.width = 26;
    icon01Img.height = 35;

    // console.log('position:', data[i]['position']);

    let marker = new AdvancedMarkerElement({
      map: map,
      position: {
        lat: Number(data[i]['position']['lat']),
        lng: Number(data[i]['position']['lng'])
      },
      content: icon01Img,
      // title: 'Rangeview High School'
    });

    markers.push(marker);
  }
  window.markers = markers;

  // let markerCluster = new MarkerClusterer({ markers: markers, 
  //   map: map,
  //   // renderer: {
  //   //   render: ({count, position}, stats) => {
  //   //     console.log('cluster renderer');
  //   //     console.log(count);
  //   //     console.log(position);
  //   //     console.log(stats);

  //   //     const color =
  //   //       count > Math.max(10, stats.clusters.markers.mean)
  //   //       ? "#ff0000"
  //   //       : "#0000ff";
  //   //     const svg = window.btoa(`
  //   //       <svg fill="${color}" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 240 240">
  //   //       <circle cx="120" cy="120" opacity=".6" r="70" />
  //   //       <circle cx="120" cy="120" opacity=".3" r="90" />
  //   //       <circle cx="120" cy="120" opacity=".2" r="110" />
  //   //       <circle cx="120" cy="120" opacity=".1" r="130" />
  //   //     </svg>`);
        
  //   //     // create marker using svg icon
  //   //     return new google.maps.Marker({
  //   //       position,
  //   //       icon: {
  //   //         url: `data:image/svg+xml;base64,${svg}`,
  //   //         scaledSize: new google.maps.Size(45, 45),
  //   //       },
  //   //       label: {
  //   //         text: String(count),
  //   //         color: "rgba(255,255,255,0.9)",
  //   //         fontSize: "12px",
  //   //       },
  //   //       // adjust zIndex to be above other markers
  //   //       zIndex: 10000000 + count,
  //   //     });
  //   //   }
  //   // }
  // });
}



document.addEventListener('DOMContentLoaded', () => {
  // initMap();
});

